import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ArrowRightIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M5.727 11.06 8.78 8 5.727 4.94l.94-.94 4 4-4 4-.94-.94Z" />
  </Icon>
);

export default memo(ArrowRightIcon);
